import React, { useState } from "react";

import {
  convertToTitleCase,
  formatNumberWithComma,
} from "../../actions/dataFormatter";
import TwoWaySortIcon from "../../assets/icons/TwoWaySortIcon";

const PERCENTAGE_COLUMNS = ["acos", "percentage", "cr", "ctr"];

// Example of Input format :
// const data = [
//     { id: 1, name: 'John'},
//     { id: 2, name: 'Jane' },
//   ];

//   const columns = [ "id", "name"];

const Table = ({ columns, rows, handleSort }) => {
  const [sortBy, setSortBy] = useState(true);

  return (
    <table
      style={{ borderCollapse: "initial" }}
      className="border-spacing-0 relative w-full bg-inherit text-white  overflow-auto"
    >
      <thead className="bg-zinc-700 sticky top-0 left-0 ">
        <tr>
          {columns.map((column, index) => (
            <th
              key={index}
              className="first:rounded-tl-md last:rounded-tr-md cursor-pointer text-center font-medium text-xs border border-l-zinc-600/[.4] border-b-zinc-700 first:border-l-zinc-600/[.4] border-r-0  last:border-r-zinc-600/[.4] border-t-zinc-600/[.4] last:border-r  border-r-zinc-600/[.7] p-1"
            >
              <div
                onClick={() => {
                  setSortBy(!sortBy);
                  handleSort({ column, sortBy: !sortBy });
                }}
                className="flex hover:bg-zinc-600 p-2 w-fit rounded-md duration-300"
              >
                <span className="min-w-fit w-max">
                  {convertToTitleCase(column)}
                </span>
                <span>
                  <TwoWaySortIcon />
                </span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex} className="hover:bg-zinc-700">
            {columns.map((column, colIndex) => {
              let hasPercentage = false;
              for (let i = 0; i < PERCENTAGE_COLUMNS.length; i++) {
                hasPercentage = column
                  .replace(/([a-z](?=[A-Z]))/g, "$1 ")
                  .toLowerCase()
                  .split(/\s|_/)
                  .find((column) => column === PERCENTAGE_COLUMNS[i]);
                if (hasPercentage) break;
              }

              return (
                <td
                  key={colIndex}
                  className={`${
                    typeof row[column] === "number" ? "text-right" : ""
                  } ${
                    rows.length === rowIndex + 1 &&
                    columns.length === colIndex + 1
                      ? "rounded-br-md"
                      : ""
                  } ${
                    rows.length === rowIndex + 1 && colIndex === 0
                      ? "rounded-bl-md"
                      : ""
                  } border-b border-l last:border-r border-zinc-700/[.55] bg-zinc-900 p-2 text-sm font-light capitalize`}
                >
                  {typeof row[column] === "number"
                    ? formatNumberWithComma({
                        value: row[column],
                        hasPercentage,
                      })
                    : row[column]}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
